import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { provideOutlet, OutletPosition } from "@spartacus/storefront";
import { AccordianAnswersComponent } from "./accordian-answers/accordian-answers.component";
import { FaqComponent } from "./faq/faq.component";


@NgModule({
  declarations: [
    FaqComponent,
    AccordianAnswersComponent
  ],
  imports: [CommonModule, NgbModule,
    MatExpansionModule,
    // FaqTitleModule
  ],
  providers: [
    provideOutlet({
      id: 'faqcontent',
      position: OutletPosition.REPLACE,
      component: FaqComponent,
    }),

  ],
})
export class FaqModule { }
